angular.module( 'acme.view.application.membership.pricing.discounts.create', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.view.application.membership.pricing.discounts.create.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var membershipPricingDiscountsCreate = {
      name: 'application.membership.pricing.discounts.create',
      url: '/create',
      views: {
        "subview-main@application": {
          controller: 'MembershipPricingDiscountsCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/pricing/discounts/create/create.tpl.html'
        }
      },
      data: {
        pageTitle: 'New membership coupon discount',
        /** Secure With Permissions **/
        permissions: ['MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_CREATE']
      }
    },
    membershipPricingDiscountsEdit = {
      name: 'application.membership.pricing.discounts.edit',
      url: '/:id/edit',
      views: {
        "subview-main@application": {
          controller: 'MembershipPricingDiscountsCreateController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/pricing/discounts/create/create.tpl.html'
        }
      },
      data: {
        pageTitle: 'Edit membership coupon discount',
        /** Secure With Permissions **/
        permissions: ['MEMBERSHIP_LIFECYCLE_ACTION_DISCOUNT_UPDATE']
      }
    };

    $stateProvider
      .state(membershipPricingDiscountsCreate)
      .state(membershipPricingDiscountsEdit);
});
